import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Materiales: React.FC = () => {
  const [materiales, setMateriales] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ nombre: '', descripcion: '', unidad: 'unidades', stockActual: 0, stockMinimo: 0 });
  const [editId, setEditId] = useState<string | null>(null);
  const [guardando, setGuardando] = useState(false);
  const [ajusteModal, setAjusteModal] = useState<{ id: string; nombre: string } | null>(null);
  const [ajuste, setAjuste] = useState({ cantidad: 0, tipo: 'entrada' as 'entrada' | 'salida' });

  const cargar = async () => {
    setLoading(true);
    try { const res = await api.get('/materiales'); setMateriales(res.data); } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const limpiar = () => { setForm({ nombre: '', descripcion: '', unidad: 'unidades', stockActual: 0, stockMinimo: 0 }); setEditId(null); };

  const editar = (m: any) => {
    setForm({ nombre: m.nombre, descripcion: m.descripcion || '', unidad: m.unidad, stockActual: Number(m.stockActual), stockMinimo: Number(m.stockMinimo) });
    setEditId(m.id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const guardar = async () => {
    if (!form.nombre.trim()) return;
    setGuardando(true);
    try {
      if (editId) await api.put(`/materiales/${editId}`, form);
      else await api.post('/materiales', form);
      limpiar();
      cargar();
    } catch { alert('Error al guardar'); }
    finally { setGuardando(false); }
  };

  const aplicarAjuste = async () => {
    if (!ajusteModal || ajuste.cantidad <= 0) return;
    try {
      await api.put(`/materiales/${ajusteModal.id}/stock`, ajuste);
      setAjusteModal(null);
      setAjuste({ cantidad: 0, tipo: 'entrada' });
      cargar();
    } catch (e: any) { alert(e?.response?.data?.message || 'Error al ajustar stock'); }
  };

  const stockBajo = materiales.filter(m => Number(m.stockActual) <= Number(m.stockMinimo));

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ color: '#f1f5f9', margin: 0, fontSize: 24, fontWeight: 800 }}>🔧 Inventario de Materiales</h2>
        <p style={{ color: '#64748b', margin: '4px 0 0', fontSize: 13 }}>Gestión de stock para averías y reparaciones</p>
      </div>

      {stockBajo.length > 0 && (
        <div style={{ background: '#ef444415', border: '2px solid #ef444455', borderRadius: 12, padding: '14px 18px', marginBottom: 20 }}>
          <div style={{ color: '#ef4444', fontWeight: 700 }}>⚠️ {stockBajo.length} material(es) con stock bajo o agotado</div>
          <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>
            {stockBajo.map(m => `${m.nombre} (${Number(m.stockActual)} ${m.unidad})`).join(' · ')}
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 20, alignItems: 'start' }}>
        {/* Formulario */}
        <div style={{ background: '#1e293b', borderRadius: 16, padding: 24, border: `1px solid ${editId ? '#0ea5e9' : '#334155'}` }}>
          <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 15, marginBottom: 16 }}>
            {editId ? 'Editar material' : 'Nuevo material'}
          </div>
          {[
            { label: 'Nombre', key: 'nombre', type: 'text', placeholder: 'Ej: Tubo PVC 1"' },
            { label: 'Descripción', key: 'descripcion', type: 'text', placeholder: 'Descripción opcional' },
            { label: 'Unidad', key: 'unidad', type: 'text', placeholder: 'unidades, metros, kg...' },
          ].map(f => (
            <div key={f.key} style={{ marginBottom: 12 }}>
              <label style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>{f.label}</label>
              <input value={(form as any)[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                placeholder={f.placeholder}
                style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any }} />
            </div>
          ))}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            {[
              { label: 'Stock actual', key: 'stockActual' },
              { label: 'Stock mínimo', key: 'stockMinimo' },
            ].map(f => (
              <div key={f.key}>
                <label style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>{f.label}</label>
                <input value={(form as any)[f.key]} type="number" min="0" step="0.01"
                  onChange={e => setForm({ ...form, [f.key]: Number(e.target.value) })}
                  style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any }} />
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={guardar} disabled={guardando}
              style={{ flex: 1, background: '#0ea5e9', border: 'none', color: 'white', borderRadius: 8, padding: '10px', cursor: 'pointer', fontWeight: 700, opacity: guardando ? 0.7 : 1 }}>
              {guardando ? 'Guardando...' : editId ? 'Actualizar' : 'Agregar'}
            </button>
            {editId && (
              <button onClick={limpiar}
                style={{ background: '#334155', border: 'none', color: '#94a3b8', borderRadius: 8, padding: '10px 16px', cursor: 'pointer' }}>
                Cancelar
              </button>
            )}
          </div>
        </div>

        {/* Lista */}
        <div style={{ background: '#1e293b', borderRadius: 16, border: '1px solid #334155', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#f1f5f9', fontWeight: 700 }}>Stock actual ({materiales.length})</span>
          </div>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 32, color: '#64748b' }}>Cargando...</div>
          ) : materiales.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 32, color: '#64748b' }}>Sin materiales registrados</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#0f172a' }}>
                  {['Material', 'Unidad', 'Stock', 'Mín.', 'Acciones'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', color: '#64748b', fontSize: 12, fontWeight: 600, textAlign: 'left' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {materiales.map(m => {
                  const bajo = Number(m.stockActual) <= Number(m.stockMinimo);
                  return (
                    <tr key={m.id} style={{ borderBottom: '1px solid #0f172a' }}>
                      <td style={{ padding: '10px 16px' }}>
                        <div style={{ color: '#f1f5f9', fontWeight: 600 }}>{m.nombre}</div>
                        {m.descripcion && <div style={{ color: '#64748b', fontSize: 11 }}>{m.descripcion}</div>}
                      </td>
                      <td style={{ padding: '10px 16px', color: '#94a3b8', fontSize: 13 }}>{m.unidad}</td>
                      <td style={{ padding: '10px 16px' }}>
                        <span style={{ color: bajo ? '#ef4444' : '#22c55e', fontWeight: 700, fontSize: 16 }}>{Number(m.stockActual)}</span>
                        {bajo && <span style={{ marginLeft: 6, color: '#ef4444', fontSize: 10, fontWeight: 700 }}>BAJO</span>}
                      </td>
                      <td style={{ padding: '10px 16px', color: '#64748b', fontSize: 13 }}>{Number(m.stockMinimo)}</td>
                      <td style={{ padding: '10px 16px' }}>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button onClick={() => setAjusteModal({ id: m.id, nombre: m.nombre })}
                            style={{ background: '#22c55e22', border: '1px solid #22c55e44', color: '#22c55e', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                            ± Stock
                          </button>
                          <button onClick={() => editar(m)}
                            style={{ background: '#0ea5e922', border: '1px solid #0ea5e944', color: '#38bdf8', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                            Editar
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal ajuste stock */}
      {ajusteModal && (
        <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div style={{ background: '#1e293b', borderRadius: 16, padding: 28, width: 360, border: '1px solid #334155' }}>
            <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 16, marginBottom: 4 }}>Ajustar stock</div>
            <div style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>{ajusteModal.nombre}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <button onClick={() => setAjuste(a => ({ ...a, tipo: 'entrada' }))}
                style={{ padding: '10px', borderRadius: 8, border: `2px solid ${ajuste.tipo === 'entrada' ? '#22c55e' : '#334155'}`, background: ajuste.tipo === 'entrada' ? '#22c55e22' : 'transparent', color: ajuste.tipo === 'entrada' ? '#22c55e' : '#64748b', fontWeight: 700, cursor: 'pointer' }}>
                📦 Entrada
              </button>
              <button onClick={() => setAjuste(a => ({ ...a, tipo: 'salida' }))}
                style={{ padding: '10px', borderRadius: 8, border: `2px solid ${ajuste.tipo === 'salida' ? '#ef4444' : '#334155'}`, background: ajuste.tipo === 'salida' ? '#ef444422' : 'transparent', color: ajuste.tipo === 'salida' ? '#ef4444' : '#64748b', fontWeight: 700, cursor: 'pointer' }}>
                📤 Salida
              </button>
            </div>
            <input type="number" min="0" step="0.01" value={ajuste.cantidad}
              onChange={e => setAjuste(a => ({ ...a, cantidad: Number(e.target.value) }))}
              placeholder="Cantidad"
              style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '10px 14px', color: 'white', fontSize: 15, boxSizing: 'border-box' as any, marginBottom: 16 }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={aplicarAjuste}
                style={{ flex: 1, background: ajuste.tipo === 'entrada' ? '#22c55e' : '#ef4444', border: 'none', color: 'white', borderRadius: 8, padding: '10px', cursor: 'pointer', fontWeight: 700 }}>
                Aplicar
              </button>
              <button onClick={() => setAjusteModal(null)}
                style={{ background: '#334155', border: 'none', color: '#94a3b8', borderRadius: 8, padding: '10px 16px', cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Materiales;
